import {UserTracker} from "../index.js";

const chatMentionEvent = [
    'main:chatting-list:click', //멘션 표시가 된 채팅방의 클릭
    'main:chatting-list:hover', //멘션 표시가 된 채팅방을 호버
    'main:notification:click', //멘션으로 Notification 된 채팅방의 클릭
    'main:notification:close', //멘션으로 Notification 된 채팅방 close
    'messenger:mention-select:enter', //채팅방에서 멘션리스트 enter 로 선택
    'messenger:mention-select:click', //채팅방에서 멘션리스트 click
    'messenger:mention-cancel:keyEvent', //멘션 작성 중 취소
    'messenger:mention-profile:click' //멘션된 사용자 프로필 클릭
]

export const MentionTracker = ({userInfo}) => {
    const Tracker = Object.create(UserTracker)
    Tracker.userInfo = userInfo
    Tracker.funcName = 'mention'
    Tracker.track = (json) => {
        if (chatMentionEvent.indexOf(json.event) < 0) {
            Mutil.log('정의되지 않은 event 입니다.')
            return
        }

        return Tracker.trackAction(json)
    }

    return Tracker
}


export function mentionTest(key) {
    const mentionTracker = MentionTracker({userInfo: '1'});
    const result =  mentionTracker?.track({event: key, value: 'test'})
    return result
}

mentionTest('messenger:mention-profile:click')
